export const ru = {
    'autobudget-priority': 'Приоритет',
    banners: 'Объявления',
    'campaign-group': 'Кампания/Группа',
    cpa: 'CPA, {currency}',
    cpc: 'CPC, {currency}',
    name: 'Название',
    price: 'Цена в объявлении',
    status: 'Статус',
    'target-funnel': 'Целевая аудитория'
};
